import type {
  ConnectButtonVariant} from '@shared/common/components/Buttons/ConnectButton';
import {
  ConnectButton
} from '@shared/common/components/Buttons/ConnectButton';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useTagManager } from '@shared/common/providers/GoogleTagManagerProvider';
import useManageTonWallet from '@shared/hooks/useManageTonWallet';
import useSelfDataCheckLocalStorage from '@shared/hooks/useSelfDataCheckLocalStorage';

import type { WalletConnectType} from '../model/walletsConfig';
import { WALLETS_CONFIG } from '../model/walletsConfig';

type Props = {
  className?: string;
  connectType: WalletConnectType;
  variant: ConnectButtonVariant;
};

const ConnectTonWalletButton = ({ className, connectType, variant }: Props) => {
  const { user, isAuth } = useAuth();
  const { tagManager } = useTagManager();
  const { setValue: setSelfDataChecksLocalStorage } = useSelfDataCheckLocalStorage();
  const { connectButtonText } = WALLETS_CONFIG[connectType];

  const { handleButtonClick, isConnectingTonWallet } = useManageTonWallet({
    isAuth,
    user,
    onSuccess: ({ walletAddress }) => {
      tagManager?.dataLayer({
        dataLayer: {
          event: 'gtm.userAddedTonWallet',
          userId: user?.id,
          tonWalletAddress: walletAddress,
        },
      });

      setSelfDataChecksLocalStorage((oldData) => {
        return {
          ...oldData,
          hasTonWallet: true,
        };
      });
    },
  });

  return (
    <ConnectButton
      className={className}
      onClick={handleButtonClick}
      disabled={isConnectingTonWallet}
      variant={variant}
    >
      {connectButtonText}
    </ConnectButton>
  );
};

export default ConnectTonWalletButton;
